module.exports = __webpack_public_path__ + "static/media/linkedin.949d72a2.svg";